 <div class="claim_body">
    <div class="top_panel">
        <h3>{{modalHeading[data?.actionModal]}}</h3>
        <span (click)="close()" class="close">
            <img src="https://cdn.elitehw.com/images/cross.webp" />
        </span>
    </div>
    <div class="formarea">
        <form [formGroup]="data?.formGroup" *ngIf="commonAssignAction.includes(data?.actionModal)">
            <div class="inputprt">
                <mat-form-field fxFlex="auto" appearance="outline">
                    <mat-label>Agent</mat-label>
                    <mat-select matNativeControl formControlName="userId">
                        <mat-option *ngFor="let item of agents"
                            value="{{item?.userId}}">{{commonService.getFullName(item?.firstName,
                            item?.lastName)}}</mat-option>
                    </mat-select>
                    <mat-error
                        *ngIf="data?.formGroup.controls['userId'].touched && data?.formGroup.controls['userId'].hasError('required')">
                        This is required field.
                    </mat-error>
                </mat-form-field>
            </div>


        </form>
        <div *ngIf="data?.actionModal === 'assignOrEditTechnician'">

            <ng-container *ngIf="currentTechnicianStep === technicianSteps.COMPANY">

                <mat-tab-group
                animationDuration="0ms"
                (selectedTabChange)="onTabChange($event)"
              >
                <mat-tab  [label]="technicianTabNames.searchCompany">
          
                    <div class="search_section" [ngClass]="{'input_adjust': searchBy === 'zipcode'}">
                        <mat-form-field fxFlex="auto" appearance="outline">
                            <mat-label>Search By</mat-label>
                            <mat-select matNativeControl [(ngModel)]="searchBy" (selectionChange)="handleSearchTechnician($event)" >
                                <mat-option value="zipcode">Zip Code</mat-option>
                                <mat-option value="state">State</mat-option>
                            </mat-select>
                        </mat-form-field>
                        <mat-form-field fxFlex="auto" appearance="outline">
                            <!-- <mat-label>Search here...</mat-label> -->
                            <input matInput [placeholder]="searchBy === 'zipcode' ? 'Search by zip code' : 'Search by state'" [(ngModel)]="technicianKeyWord" (input)="searchCompanyByKeyword()" [mask]="searchBy === 'zipcode' ? '0*' : ''" [required]="radius && searchBy === 'zipcode' ? true : false" [maxlength]="searchBy === 'zipcode' ? 5 : 999"  #inputField="ngModel">
                            <mat-error *ngIf="inputField.invalid && inputField.touched">
                                This field is required.
                            </mat-error>
                        </mat-form-field>
                        <mat-form-field fxFlex="auto" appearance="outline" *ngIf="searchBy === 'zipcode'">
                            <input matInput placeholder="Radius" [(ngModel)]="radius" mask="separator.2" suffix=" Miles" thousandSeparator="," (input)="searchCompanyByKeyword()">
                        </mat-form-field>
                        <mat-form-field fxFlex="auto" appearance="outline">
                            <mat-label>Trades</mat-label>
                            <mat-select multiple [formControl]="serviceIds"  (selectionChange)="serviceSelectionChange($event)">
                              <mat-option *ngFor="let item of data?.services" [value]="item?.serviceId">{{item.title}}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <form [formGroup]="data?.formGroup">
                        <div>
                            <fury-list>
                                <div class="table table_container">
                                  <table mat-table [dataSource]="agents">
                                    <ng-container matColumnDef="selectCompany">
                                      <th mat-header-cell *matHeaderCellDef>Select Company</th>
                                      <td mat-cell *matCellDef="let element">
                                        <span><input type="radio" formControlName="userId" [value]="element?.userId"></span>
                                      </td>
                                    </ng-container>
                                     <ng-container matColumnDef="companyName">
                                      <th mat-header-cell *matHeaderCellDef>Company Name</th>
                                      <td mat-cell *matCellDef="let element">
                                        {{element?.firstName}} {{element?.lastName}}
                                      </td>
                                    </ng-container>
                                    <ng-container matColumnDef="companyRating">
                                        <th mat-header-cell *matHeaderCellDef>Company Rating</th>
                                        <td mat-cell *matCellDef="let element">
                                          {{element?.companyRating}}
                                        </td>
                                      </ng-container>
                                      <ng-container matColumnDef="performanceScore">
                                        <th mat-header-cell *matHeaderCellDef>Performance Score</th>
                                        <td mat-cell *matCellDef="let element">
                                          {{element?.performanceScore}}
                                        </td>
                                      </ng-container>
                                    <ng-container matColumnDef="distance">
                                        <th mat-header-cell *matHeaderCellDef>Distance (Miles)</th>
                                        <td mat-cell *matCellDef="let element">
                                            <span class="textRed">{{element?.miles}}</span>
                                        </td>
                                      </ng-container>
                                      <ng-container matColumnDef="phoneNo">
                                        <th mat-header-cell *matHeaderCellDef>Phone No</th>
                                        <td mat-cell *matCellDef="let element">
                                            {{element?.phoneNumber | mask: '(000) 000-0000'}}
                                        </td>
                                      </ng-container>
                                      <ng-container matColumnDef="emailAddress">
                                        <th mat-header-cell *matHeaderCellDef>Email Id</th>
                                        <td mat-cell *matCellDef="let element">
                                            {{element?.emailAddress}}
                                        </td>
                                      </ng-container>
                                      <ng-container matColumnDef="trade">
                                        <th mat-header-cell *matHeaderCellDef>Trades</th>
                                        <td mat-cell *matCellDef="let element">
                                            <div class="maxTxt">
                                                {{element?.tradesList}}
                                            </div>
                                        </td>
                                      </ng-container>
                              
                                    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                                    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                                  </table>
                                  <div
                                  *ngIf="agents?.length === 0"
                                    style="padding: 10px 0; text-align: center"
                                  >
                                  No company found.
                                  </div>
                                </div>
                              </fury-list>
                            <mat-error
                                *ngIf="data?.formGroup.controls['userId'].touched && data?.formGroup.controls['userId'].hasError('required')">
                                Please select a company.
                            </mat-error>
                        </div>
            
                    </form>
                </mat-tab>
                <mat-tab [label]="technicianTabNames.addNewCompany">
                    <div class="scroll_container">
                        <fury-add-company [services]="this.data?.services"></fury-add-company>
                    </div>
                   
                </mat-tab>
              </mat-tab-group>
            </ng-container>
    
            <ng-container *ngIf="currentTechnicianStep === technicianSteps.TECHNICIAN">

                <mat-tab-group
                animationDuration="0ms"
                (selectedTabChange)="onTabChange($event)"
              >
                <mat-tab [label]="technicianTabNames.searchTechnician">
                    <form [formGroup]="data?.formGroup">
                        <div class="inputprt technician">
                            <mat-form-field fxFlex="auto" appearance="outline" *ngIf="agents?.length > 0">
                                <mat-label>Technician</mat-label>
                                <mat-select matNativeControl formControlName="technicianId">
                                    <mat-option
                                    [value]="null">None</mat-option>

                                    <mat-option *ngFor="let item of allTechnicians"
                                        value="{{item?.technicianId}}">{{commonService.getFullName(item?.firstName,
                                        item?.lastName)}}</mat-option>
                                </mat-select>
                                <mat-error
                                    *ngIf="data?.formGroup.controls['technicianId'].touched && data?.formGroup.controls['technicianId'].hasError('required')">
                                    This is required field.
                                </mat-error>
                            </mat-form-field>
                            <p *ngIf="agents?.length === 0" style="text-align: center;">No technician found.</p>
                        </div>
            
            
                    </form>
                </mat-tab>
                <mat-tab [label]="technicianTabNames.addNewTechnician">
                    <div class="scroll_container">
                        <fury-add-company [services]="this.data?.services" [selectedCompany]="selectedCompany"></fury-add-company>
                    </div>
                </mat-tab>
              </mat-tab-group>
            </ng-container>


        </div>
        <form [formGroup]="data?.formGroup"  *ngIf="commonInputActionField.includes(data?.actionModal)">
            <div class="inputprt">
                <mat-form-field fxFlex="auto" appearance="outline">
                    <mat-label>{{commonInputTitle[data?.actionModal]}}</mat-label>
                    <input matInput [placeholder]="commonInputTitle[data?.actionModal]" formControlName="value">
                    <mat-error
                        *ngIf="data?.formGroup.controls['value'].touched && data?.formGroup.controls['value'].hasError('required')">
                        This is required field.
                    </mat-error>
                </mat-form-field>
                <mat-form-field fxFlex="auto" appearance="outline" class="fullwidth">
                    <mat-label>Note</mat-label>
                    <textarea
                    matInput
                    cdkTextareaAutosize
                    #autosize="cdkTextareaAutosize"
                    cdkAutosizeMinRows="5"
                    cdkAutosizeMaxRows="5"
                    formControlName="note"
                  ></textarea>
                    <mat-error
                        *ngIf="data?.formGroup.controls['note'].touched && data?.formGroup.controls['note'].hasError('required')">
                        This is required field.
                    </mat-error>
                </mat-form-field>
            </div>
        </form>

        <form [formGroup]="data?.formGroup"   *ngIf="data?.actionModal === 'escalateClaim'">
            <div class="inputprt">

                <mat-form-field fxFlex="auto" appearance="outline">
                    <mat-label>Supervisor</mat-label>
                    <mat-select matNativeControl formControlName="value">
                        <mat-option *ngFor="let item of agents"
                            value="{{item?.userId}}">{{commonService.getFullName(item?.firstName,
                            item?.lastName)}}</mat-option>
                    </mat-select>
                    <mat-error
                        *ngIf="data?.formGroup.controls['value'].touched && data?.formGroup.controls['value'].hasError('required')">
                        This is required field.
                    </mat-error>
                </mat-form-field>
                
                <mat-form-field fxFlex="auto" appearance="outline" class="fullwidth">
                    <mat-label>Note</mat-label>
                    <textarea
                    matInput
                    cdkTextareaAutosize
                    #autosize="cdkTextareaAutosize"
                    cdkAutosizeMinRows="5"
                    cdkAutosizeMaxRows="5"
                    formControlName="note"
                  ></textarea>
                    <mat-error
                        *ngIf="data?.formGroup.controls['note'].touched && data?.formGroup.controls['note'].hasError('required')">
                        This is required field.
                    </mat-error>
                </mat-form-field>
            </div>
        </form>


        <form [formGroup]="data?.formGroup"  *ngIf="data?.actionModal === 'orderParts'">
            <div class="inputprt">
                <mat-form-field fxFlex="auto" appearance="outline">
                    <mat-label>Part Name</mat-label>
                    <input matInput [placeholder]="'Enter part name'" formControlName="name">
                    <mat-error
                        *ngIf="data?.formGroup.controls['name'].touched && data?.formGroup.controls['name'].hasError('required')">
                        This is required field.
                    </mat-error>
                </mat-form-field>



                <mat-form-field fxFlex="auto" appearance="outline">
                    <mat-label>Make</mat-label>
                    <input matInput [placeholder]="'Make'" formControlName="make">
                    <mat-error
                        *ngIf="data?.formGroup.controls['make'].touched && data?.formGroup.controls['make'].hasError('required')">
                        This is required field.
                    </mat-error>
                </mat-form-field>

                
                <mat-form-field fxFlex="auto" appearance="outline">
                    <mat-label>Model</mat-label>
                    <input matInput [placeholder]="'Model'" formControlName="model">
                    <mat-error
                        *ngIf="data?.formGroup.controls['model'].touched && data?.formGroup.controls['model'].hasError('required')">
                        This is required field.
                    </mat-error>
                </mat-form-field>

                <mat-form-field fxFlex="auto" appearance="outline">
                    <mat-label>Serial Number</mat-label>
                    <input matInput [placeholder]="'Serial Number'" formControlName="serial">
                    <mat-error
                        *ngIf="data?.formGroup.controls['serial'].touched && data?.formGroup.controls['serial'].hasError('required')">
                        This is required field.
                    </mat-error>
                </mat-form-field>

                <mat-form-field fxFlex="auto" appearance="outline">
                    <mat-label>Cost</mat-label>
                    <input matInput [placeholder]="'Cost'" formControlName="cost" mask="separator.2" prefix="$" thousandSeparator=",">
                    <mat-error
                        *ngIf="data?.formGroup.controls['cost'].touched && data?.formGroup.controls['cost'].hasError('required')">
                        This is required field.
                    </mat-error>
                </mat-form-field>
            </div>
        </form>
        <form [formGroup]="data?.formGroup"  *ngIf="commonMaskedInputField.includes(data?.actionModal)">
            <div class="inputprt">
                <mat-form-field fxFlex="auto" appearance="outline">
                    <mat-label>{{commonInputTitle[data?.actionModal]}}</mat-label>
                    <input matInput [placeholder]="commonInputTitle[data?.actionModal]" formControlName="value" mask="separator.2" prefix="$" thousandSeparator=",">
                    <mat-error
                        *ngIf="data?.formGroup.controls['value'].touched && data?.formGroup.controls['value'].hasError('required')">
                        This is required field.
                    </mat-error>
                </mat-form-field>
            </div>
        </form>
        <form [formGroup]="data?.formGroup"  *ngIf="commonMaskedInputFieldWithNote.includes(data?.actionModal)">
            <div class="inputprt">
                <mat-form-field fxFlex="auto" appearance="outline">
                    <mat-label>{{commonInputTitle[data?.actionModal]}}</mat-label>
                    <input matInput [placeholder]="commonInputTitle[data?.actionModal]" formControlName="value" mask="separator.2" prefix="$" thousandSeparator=",">
                    <mat-error
                        *ngIf="data?.formGroup.controls['value'].touched && data?.formGroup.controls['value'].hasError('required')">
                        This is required field.
                    </mat-error>
                </mat-form-field>
                <mat-form-field fxFlex="auto" appearance="outline" class="fullwidth">
                    <mat-label>Note</mat-label>
                    <textarea
                    matInput
                    cdkTextareaAutosize
                    #autosize="cdkTextareaAutosize"
                    cdkAutosizeMinRows="5"
                    cdkAutosizeMaxRows="5"
                    formControlName="note"
                  ></textarea>
                    <mat-error
                        *ngIf="data?.formGroup.controls['note'].touched && data?.formGroup.controls['note'].hasError('required')">
                        This is required field.
                    </mat-error>
                </mat-form-field>
            </div>
        </form>
        <form [formGroup]="data?.formGroup" *ngIf="data?.actionModal === 'addTechnicianSchedule'">
            <div class="inputprt">
                <mat-form-field fxFlex="auto" appearance="outline">
                    <mat-label>Technician Name</mat-label>
                    <input matInput placeholder="Technician Name" formControlName="technicianName" readonly>
                </mat-form-field>
                <mat-form-field fxFlex="auto" appearance="outline">
                    <mat-label>Technician Schedule Date and Time</mat-label>
                    <input matInput [ngxMatDatetimePicker]="picker" placeholder="Choose a date and time" formControlName="value"
                      [min]="datePicker.minDate" [disabled]="datePicker.disabled" readonly (click)="handleDateOpen()">
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <ngx-mat-datetime-picker #picker [showSpinners]="datePicker.showSpinners" [showSeconds]="datePicker.showSeconds"
                      [stepHour]="datePicker.stepHour" [stepMinute]="datePicker.stepMinute" [stepSecond]="datePicker.stepSecond" [touchUi]="datePicker.touchUi"
                      [color]="datePicker.color" [enableMeridian]="datePicker.enableMeridian">
                    </ngx-mat-datetime-picker>
                    <mat-error
                        *ngIf="data?.formGroup.controls['value'].touched && data?.formGroup.controls['value'].hasError('required')">
                        This is required field.
                    </mat-error>
                    <mat-error
                    *ngIf="data?.formGroup.controls['value'].touched && data?.formGroup.controls['value'].hasError('notValid')">
                    Selected date and time should be greater than current date and time.
                </mat-error>
                  </mat-form-field>

                  <mat-form-field fxFlex="auto" appearance="outline">
                    <mat-label>Arrival Window</mat-label>
                    <mat-select matNativeControl formControlName="arrivalWindow">
                        <mat-option value="1-2 hours">1 - 2 Hours</mat-option>
                        <mat-option value="2-3 hours">2 - 3 Hours</mat-option>
                        <mat-option value="3-4 hours">3 - 4 Hours</mat-option>
                        <mat-option value="4-5 hours">4 - 5 Hours</mat-option>
                        <mat-option value="5-6 hours">5 - 6 Hours</mat-option>
                        <mat-option value="6-7 hours">6 - 7 Hours</mat-option>
                    </mat-select>
                    <mat-error
                    *ngIf="data?.formGroup.controls['arrivalWindow'].touched && data?.formGroup.controls['arrivalWindow'].hasError('required')">
                    This is required field.
                </mat-error>

                </mat-form-field>

             
                    <mat-form-field fxFlex="auto" appearance="outline">
                        <mat-label>Applied To Repair</mat-label>
                        <mat-select matNativeControl formControlName="appliedToRepair">
                         <mat-option [value]="true">Yes</mat-option>
                         <mat-option [value]="false">No</mat-option>
                     </mat-select>

                     <mat-error
                     *ngIf="data?.formGroup.controls['appliedToRepair'].touched && data?.formGroup.controls['appliedToRepair'].hasError('required')">
                     This is required field.
                 </mat-error>

                     </mat-form-field>
            
                <mat-form-field fxFlex="auto" appearance="outline">
                    <mat-label>Technician Ratings</mat-label>
                    <input type="number" matInput placeholder="Technician Ratings" step="1"
                    onkeypress="return event.charCode >= 48 && event.charCode <= 57" min="1" max="10" formControlName="technicianRatings">
                    <mat-error
                    *ngIf="data?.formGroup.controls['technicianRatings'].touched && data?.formGroup.controls['technicianRatings'].hasError('required')">
                    This is required field.
                </mat-error>
                
                <mat-error
                *ngIf="data?.formGroup.controls['technicianRatings'].touched && (data?.formGroup.controls['technicianRatings'].hasError('min') || data?.formGroup.controls['technicianRatings'].hasError('max'))">
                Please provide value between 1 and 10
            </mat-error>

                </mat-form-field>

                <mat-form-field fxFlex="auto" appearance="outline" class="fullwidth">
                    <mat-label>Scheduled Appointment Note</mat-label>
                    <textarea matInput formControlName="scheduledAppointmentNote"></textarea>
                    <mat-error
                    *ngIf="data?.formGroup.controls['scheduledAppointmentNote'].touched && data?.formGroup.controls['scheduledAppointmentNote'].hasError('required')">
                    This is required field.
                </mat-error>

                </mat-form-field>
            </div>
        </form>
        <form [formGroup]="data?.formGroup" *ngIf="data?.actionModal === 'uploadDiagnosis'">
            <div class="inputprt">
                <div class="uploadbtnsec">
                    <div>
                        <div class="fileflex">
                            <input type="file" #fileOpen (change)="onFileUpload($event)" accept="application/pdf, image/*"
                            style="display:none">
                            <button class="uploadfilebtn" mat-raised-button (click)="fileOpen.click()">Upload File</button>
                            <p>{{fileName}}</p>
                        </div>
                        <mat-error
                        *ngIf="data?.formGroup.controls['value'].touched && data?.formGroup.controls['value'].hasError('required')">
                        Please select an image or pdf file.
                        </mat-error>
                    </div>
                    
                   
                </div>
                <div>
                    <mat-form-field fxFlex="auto" appearance="outline" class="fullwidth">
                        <mat-label>Note</mat-label>
                        <textarea
                        matInput
                        cdkTextareaAutosize
                        #autosize="cdkTextareaAutosize"
                        cdkAutosizeMinRows="5"
                        cdkAutosizeMaxRows="5"
                        formControlName="note"
                      ></textarea>
                        <mat-error
                            *ngIf="data?.formGroup.controls['note'].touched && data?.formGroup.controls['note'].hasError('required')">
                            This is required field.
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>


        </form>
        <form [formGroup]="data?.formGroup" *ngIf="data?.actionModal === 'updateClaimInfo'">
            <div class="inputprt">
                <mat-form-field fxFlex="auto" appearance="outline">
                    <mat-label>Phone Number</mat-label>
                    <input matInput placeholder='Enter phone number' formControlName="phoneNumber" mask="(000) 000-0000">
                    <mat-error
                        *ngIf="data?.formGroup.controls['phoneNumber'].touched && data?.formGroup.controls['phoneNumber'].hasError('required')">
                        This is required field.
                    </mat-error>
                    <mat-error
                        *ngIf="data?.formGroup.controls['phoneNumber'].touched && data?.formGroup.controls['phoneNumber'].hasError('pattern')">
                        Please enter valid phone number.
                    </mat-error>
                </mat-form-field>
                <mat-form-field fxFlex="auto" appearance="outline">
                    <mat-label>Email Address</mat-label>
                    <input matInput placeholder='Enter email address' formControlName="emailAddress">
                    <mat-error
                        *ngIf="data?.formGroup.controls['emailAddress'].touched && data?.formGroup.controls['emailAddress'].hasError('required')">
                        This is required field.
                    </mat-error>
                    <mat-error
                        *ngIf="data?.formGroup.controls['emailAddress'].touched && data?.formGroup.controls['emailAddress'].hasError('pattern')">
                        Please enter valid email address.
                    </mat-error>
                </mat-form-field>
                <mat-form-field fxFlex="auto" appearance="outline">
                    <mat-label>Contact Person</mat-label>
                    <input matInput placeholder='Contact Person' formControlName="contactPerson">
                    <mat-error
                        *ngIf="data?.formGroup.controls['contactPerson'].touched && data?.formGroup.controls['contactPerson'].hasError('required')">
                        This is required field.
                    </mat-error>
                </mat-form-field>
                <mat-form-field fxFlex="auto" appearance="outline">
                    <mat-label>Contact Phone Number</mat-label>
                    <input matInput placeholder='Enter phone number' formControlName="contactPhoneNumber" mask="(000) 000-0000">
                    <mat-error
                        *ngIf="data?.formGroup.controls['contactPhoneNumber'].touched && data?.formGroup.controls['contactPhoneNumber'].hasError('required')">
                        This is required field.
                    </mat-error>
                    <mat-error
                        *ngIf="data?.formGroup.controls['contactPhoneNumber'].touched && data?.formGroup.controls['contactPhoneNumber'].hasError('pattern')">
                        Please enter valid phone number.
                    </mat-error>
                </mat-form-field>
                <mat-form-field fxFlex="auto" appearance="outline">
                    <mat-label>Contact Email Address</mat-label>
                    <input matInput placeholder='Enter email address' formControlName="contactEmailAddress">
                    <mat-error
                        *ngIf="data?.formGroup.controls['contactEmailAddress'].touched && data?.formGroup.controls['contactEmailAddress'].hasError('required')">
                        This is required field.
                    </mat-error>
                    <mat-error
                        *ngIf="data?.formGroup.controls['contactEmailAddress'].touched && data?.formGroup.controls['contactEmailAddress'].hasError('pattern')">
                        Please enter valid email address.
                    </mat-error>
                </mat-form-field>
                <mat-form-field fxFlex="auto" appearance="outline" class="fullwidth">
                    <mat-label>Note</mat-label>
                    <textarea
                    matInput
                    cdkTextareaAutosize
                    #autosize="cdkTextareaAutosize"
                    cdkAutosizeMinRows="5"
                    cdkAutosizeMaxRows="5"
                    formControlName="updateClaimInfoNote"
                  ></textarea>
                    <mat-error
                        *ngIf="data?.formGroup.controls['updateClaimInfoNote'].touched && data?.formGroup.controls['updateClaimInfoNote'].hasError('required')">
                        This is required field.
                    </mat-error>
                </mat-form-field>
            </div>
        </form>
        <form [formGroup]="data?.formGroup"  *ngIf="data?.actionModal === 'cancelClaim'">
            <div class="inputprt">
                <mat-form-field fxFlex="auto" appearance="outline" class="fullwidth">
                    <mat-label>Note</mat-label>
                    <textarea
                    matInput
                    cdkTextareaAutosize
                    #autosize="cdkTextareaAutosize"
                    cdkAutosizeMinRows="5"
                    cdkAutosizeMaxRows="5"
                    formControlName="note"
                  ></textarea>
                    <mat-error
                        *ngIf="data?.formGroup.controls['note'].touched && data?.formGroup.controls['note'].hasError('required')">
                        This is required field.
                    </mat-error>
                </mat-form-field>
            </div>
        </form>

        <form [formGroup]="data?.formGroup"  *ngIf="data?.actionModal === 'assignCurrentUser'">
            <div class="inputprt">
        <mat-form-field appearance="outline" style="width: 100%">
            <mat-label>Current User</mat-label>
            <mat-select multiple formControlName="value">
              <mat-option  *ngFor="let item of agents"
              value="{{item?.userId}}">{{commonService.getFullName(item?.firstName,
                item?.lastName)}}</mat-option>
            </mat-select>
            <mat-error
            *ngIf="
            data?.formGroup.controls['value'].touched &&
            data?.formGroup.controls['value'].hasError('required')
            "
          >
            This is a required field.</mat-error>
        </mat-form-field>
            </div>
         </form>
         <form [formGroup]="data?.formGroup"  *ngIf="data?.actionModal === 'orderReplacement'">
            <div class="inputprt claim_replace">
                <mat-form-field fxFlex="auto" appearance="outline">
                    <mat-label>Order From</mat-label>
                    <input matInput placeholder="Order From" formControlName="orderedFrom">
                    <mat-error
                        *ngIf="data?.formGroup.controls['orderedFrom'].touched && data?.formGroup.controls['orderedFrom'].hasError('required')">
                        This is required field.
                    </mat-error>
                </mat-form-field>
                <mat-form-field appearance="outline">
                    <mat-label>Order Date</mat-label>
                    <input matInput [matDatepicker]="picker" formControlName="orderedDate" (click)="picker.open()" readonly [min]="datePicker?.minDate">
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                    <mat-error
                    *ngIf="data?.formGroup.controls['orderedDate'].touched && data?.formGroup.controls['orderedDate'].hasError('required')">
                    This is required field.
                </mat-error>
                </mat-form-field>
                <mat-form-field fxFlex="auto" appearance="outline">
                    <mat-label>Tracking #</mat-label>
                    <input matInput placeholder="Tracking #" formControlName="tracking">
                    <mat-error
                        *ngIf="data?.formGroup.controls['tracking'].touched && data?.formGroup.controls['tracking'].hasError('required')">
                        This is required field.
                    </mat-error>
                </mat-form-field>
                <mat-form-field appearance="outline">
                    <mat-label>Delivery Date</mat-label>
                    <input matInput [matDatepicker]="picker1" formControlName="deliveryDate" (click)="picker1.open()" readonly [min]="datePicker?.minDate">
                    <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                    <mat-datepicker #picker1></mat-datepicker>
                    <mat-error
                    *ngIf="data?.formGroup.controls['deliveryDate'].touched && data?.formGroup.controls['deliveryDate'].hasError('required')">
                    This is required field.
                </mat-error>
                </mat-form-field>
                <mat-form-field fxFlex="auto" appearance="outline">
                    <mat-label>Item Type</mat-label>
                    <input matInput placeholder="Item Type" formControlName="itemType">
                    <mat-error *ngIf="data?.formGroup.controls['itemType'].touched && data?.formGroup.controls['itemType'].hasError('required')">
                        This is required field.
                    </mat-error>
                </mat-form-field>
                <mat-form-field fxFlex="auto" appearance="outline">
                    <mat-label>Age of Item</mat-label>
                    <input matInput placeholder="Age of Item" formControlName="ageOfItem">
                    <mat-error
                        *ngIf="data?.formGroup.controls['ageOfItem'].touched && data?.formGroup.controls['ageOfItem'].hasError('required')">
                        This is required field.
                    </mat-error>
                </mat-form-field>
                <mat-form-field fxFlex="auto" appearance="outline">
                    <mat-label>Brand</mat-label>
                    <input matInput placeholder="Brand" formControlName="brand">
                    <mat-error
                        *ngIf="data?.formGroup.controls['brand'].touched && data?.formGroup.controls['brand'].hasError('required')">
                        This is required field.
                    </mat-error>
                </mat-form-field>
                <mat-form-field fxFlex="auto" appearance="outline">
                    <mat-label>Model #</mat-label>
                    <input matInput placeholder="Model #" formControlName="model">
                    <mat-error
                        *ngIf="data?.formGroup.controls['model'].touched && data?.formGroup.controls['model'].hasError('required')">
                        This is required field.
                    </mat-error>
                </mat-form-field>
                <mat-form-field fxFlex="auto" appearance="outline">
                    <mat-label>Serial #</mat-label>
                    <input matInput placeholder="Serial #" formControlName="serial">
                    <mat-error
                        *ngIf="data?.formGroup.controls['serial'].touched && data?.formGroup.controls['serial'].hasError('required')">
                        This is required field.
                    </mat-error>
                </mat-form-field>
                <mat-form-field fxFlex="auto" appearance="outline">
                    <mat-label>Color</mat-label>
                    <input matInput placeholder="Color" formControlName="color">
                    <mat-error
                        *ngIf="data?.formGroup.controls['color'].touched && data?.formGroup.controls['color'].hasError('required')">
                        This is required field.
                    </mat-error>
                </mat-form-field>
                <mat-form-field fxFlex="auto" appearance="outline">
                    <mat-label>Size</mat-label>
                    <input matInput placeholder="Size" formControlName="size">
                    <mat-error
                        *ngIf="data?.formGroup.controls['size'].touched && data?.formGroup.controls['size'].hasError('required')">
                        This is required field.
                    </mat-error>
                </mat-form-field>
                <mat-form-field appearance="outline">
                    <mat-label>Hallaway</mat-label>
                    <mat-select formControlName="hallaway">
                      <mat-option [value]="true">Yes</mat-option>
                      <mat-option [value]="false">No</mat-option>
                    </mat-select>
                    <mat-error
                    *ngIf="
                    data?.formGroup.controls['hallaway'].touched &&
                    data?.formGroup.controls['hallaway'].hasError('required')
                    "
                  >
                    This is a required field.</mat-error>
                </mat-form-field>
                <mat-form-field fxFlex="auto" appearance="outline">
                    <mat-label>Item Cost</mat-label>
                    <input matInput placeholder="Item Cost" formControlName="itemCost" mask="separator.2" prefix="$" thousandSeparator=",">
                    <mat-error *ngIf="data?.formGroup.controls['itemCost'].touched && data?.formGroup.controls['itemCost'].hasError('required')">
                        This is required field.
                    </mat-error>
                </mat-form-field>
                <mat-form-field fxFlex="auto" appearance="outline">
                    <mat-label>Installation cost</mat-label>
                    <input matInput placeholder="Installation cost" formControlName="installationCost" mask="separator.2" prefix="$" thousandSeparator=",">
                    <mat-error *ngIf="data?.formGroup.controls['installationCost'].touched && data?.formGroup.controls['installationCost'].hasError('required')">
                        This is required field.
                    </mat-error>
                </mat-form-field>
                <mat-form-field fxFlex="auto" appearance="outline">
                    <mat-label>Hallaway Cost</mat-label>
                    <input matInput placeholder="Hallaway Cost" formControlName="hallawayCost" mask="separator.2" prefix="$" thousandSeparator=",">
                    <mat-error *ngIf="data?.formGroup.controls['hallawayCost'].touched && data?.formGroup.controls['hallawayCost'].hasError('required')">
                        This is required field.
                    </mat-error>
                </mat-form-field>
                <mat-form-field fxFlex="auto" appearance="outline">
                    <mat-label>Outcome</mat-label>
                    <input matInput placeholder="Outcome" formControlName="outcome">
                    <mat-error *ngIf="data?.formGroup.controls['outcome'].touched && data?.formGroup.controls['outcome'].hasError('required')">
                        This is required field.
                    </mat-error>
                </mat-form-field>
                <mat-form-field fxFlex="auto" appearance="outline" class="fullwidth">
                    <mat-label>Note</mat-label>
                    <textarea
                    matInput
                    cdkTextareaAutosize
                    #autosize="cdkTextareaAutosize"
                    cdkAutosizeMinRows="5"
                    cdkAutosizeMaxRows="5"
                    formControlName="notes"
                  ></textarea>
                    <mat-error
                        *ngIf="data?.formGroup.controls['notes'].touched && data?.formGroup.controls['notes'].hasError('required')">
                        This is required field.
                    </mat-error>
                </mat-form-field>
                <mat-form-field fxFlex="auto" appearance="outline" class="fullwidth">
                    <mat-label>Completed Note</mat-label>
                    <textarea
                    matInput
                    cdkTextareaAutosize
                    #autosize="cdkTextareaAutosize"
                    cdkAutosizeMinRows="5"
                    cdkAutosizeMaxRows="5"
                    formControlName="completedNote"
                  ></textarea>
                    <mat-error
                        *ngIf="data?.formGroup.controls['completedNote'].touched && data?.formGroup.controls['completedNote'].hasError('required')">
                        This is required field.
                    </mat-error>
                </mat-form-field>
            </div>
        </form>
        <div class="actions" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="8px" *ngIf="showButtonsSection">
            <ng-container *ngIf="data?.actionModal === 'assignOrEditTechnician'">
                <button mat-button type="button"  *ngIf=" currentTechnicianStep === technicianSteps.TECHNICIAN" class="can-button" (click)="onBack()"><span>Back</span></button>
                <button mat-button type="button"  *ngIf=" currentTechnicianStep === technicianSteps.COMPANY" class="sub-button" (click)="onNext()"><span>Next</span></button>
                <button mat-button type="button" *ngIf=" currentTechnicianStep === technicianSteps.TECHNICIAN && data?.formGroup.controls['technicianId'].value" class="sub-button green" (click)="onSubmit(true)"><span>Assign & Schedule</span></button>
                <button mat-button type="button" *ngIf=" currentTechnicianStep === technicianSteps.TECHNICIAN" class="sub-button" (click)="onSubmit()"><span>{{data?.formGroup.controls['technicianId'].value ? "Assign & Schedule later" : "Assign"}}</span></button>
                <button mat-button type="button" class="can-button" (click)="close()"><span>Cancel</span></button>
            </ng-container>

            <ng-container *ngIf="data?.actionModal !== 'assignOrEditTechnician'">
            <button mat-button type="button" class="sub-button" (click)="onSubmit()"><span>{{modalButton[data?.actionModal]}}</span></button>
            <button mat-button type="button" class="can-button" (click)="close()"><span>Cancel</span></button>
        </ng-container>
        </div>
    </div>
</div>